<script setup lang="ts">
import UserNotConnected from './UserNotConnected.vue'

const emits = defineEmits(['closePopUp'])

const body = ref(document.querySelector('body') as HTMLElement)

onMounted(() => {
    window.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            closePopUp()
        }
    })
    body.value.classList.add('overflow-hidden')
    body.value.style.removeProperty('overflow')
})

const closePopUp = () => {
    emits('closePopUp')

    if (body.value) {
        body.value.classList.remove('overflow-hidden')
    }
}
</script>

<template>
    <div
        class="z-10 absolute w-screen h-screen flex justify-center items-center"
    >
        <span
            class="absolute bg-black opacity-40 h-screen w-screen"
            @click="closePopUp"
        />
        <div
            class="relative h-screen overflow-auto bg-white z-10 md:flex md:flex-col md:justify-center rounded-2xl"
        >
            <UserNotConnected is-contained-in-popup @closePopUp="closePopUp" />
        </div>
    </div>
</template>
